import { combineReducers } from "redux";
import * as authentication from "./Authentication/reducers";
import * as review from "./Payslip/reducers";
import * as content from "./Taxdocument/reducers";

export default combineReducers({
    ...authentication,
    ...review,
    ...content
});